const Tabs = ({
  activeTab = "orders",
  onChange,
}) => {
  return (
    <div className="border-bottom mb-3">
      <div className="d-flex gap-4 px-2">

        <button
          className={`btn btn-sm border-0 fw-semibold ${
            activeTab?.toLowerCase() === "orders"
              ? "text-primary border-bottom border-2 border-primary"
              : "text-muted"
          }`}
          onClick={() => onChange("orders")}
        >
          Orders
        </button>

        <button
          className={`btn btn-sm border-0 fw-semibold ${
            activeTab?.toLowerCase() === "menus"
              ? "text-primary border-bottom border-2 border-primary"
              : "text-muted"
          }`}
          onClick={() => onChange("menus")}
        >
          Menus
        </button>

        <button
          className={`btn btn-sm border-0 fw-semibold ${
            activeTab?.toLowerCase() === "items"
              ? "text-success border-bottom border-2 border-success"
              : "text-muted"
          }`}
          onClick={() => onChange("items")}
        >
          Items
        </button>

      </div>
    </div>
  );
};

export default Tabs;
